import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as FolderIcon } from 'img/familyDocuments/folder.svg';
import store from 'lib/store';
import React, { type FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_FAMILY_USER, USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { hasNewTableGrid } from 'reactApp/appHelpers/featuresHelpers/features/datalistNewTableGrid';
import { useFamilyShowPreviewHook } from 'reactApp/hooks/useFamilyShowHook';
import { familyDocumentsEnableAction } from 'reactApp/modules/family/family.actions';
import { isUserFamilyOwner } from 'reactApp/modules/family/family.selectors';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { renderFamilyDocumentsModal } from 'reactApp/ui/FamilyDocumentsModal/FamilyDocumentsModal.helper';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './DataLIstItemFamilyDocumentsFakeDoor.css';

interface DataListItemFamilyDocumentsFakeDoorProps {
    viewMode: EViewMode;
}

export const DataListItemFamilyDocumentsFakeDoor: FC<DataListItemFamilyDocumentsFakeDoorProps> = ({ viewMode }) => {
    const isFamilyFeaturePreview = useFamilyShowPreviewHook();
    const dispatch = useDispatch();
    const storage = useSelector(getCurrentStorage);
    const isFamilyOwner = useSelector(isUserFamilyOwner);

    useEffect(() => {
        sendDwh({
            eventCategory: 'folder-family-docs-fake',
            action: 'show',
            dwhData: {
                source: storage === 'home' ? 'home' : 'family',
                is_family_member: IS_FAMILY_USER,
            },
        });
    }, []);

    const onClickHandler = useCallback(() => {
        sendDwh({
            eventCategory: 'folder-family-docs-fake',
            action: 'click',
            dwhData: {
                source: storage === 'home' ? 'home' : 'family',
                is_family_member: IS_FAMILY_USER,
            },
        });
        if (isFamilyFeaturePreview) {
            store.set(`${USER_EMAIL}|family-documents-datalist-item`, true);
            dispatch(historyPush({ id: `/family/folders` }));
        } else {
            renderFamilyDocumentsModal({
                onClick: () => {
                    dispatch(familyDocumentsEnableAction());
                },
            });
        }
    }, [isFamilyFeaturePreview, storage, isFamilyOwner]);

    if (viewMode === EViewMode.list) {
        return (
            <div className={classNames(styles.root, styles.list)} onClick={onClickHandler}>
                <Checkbox className={styles.listCheckbox} isSelected={false} onCheckboxClick={onClickHandler} viewType={EViewMode.list} />
                <div className={styles.iconContainer} />
                <div className={styles.details}>
                    <div className={styles.titleContainer}>
                        <Text className={styles.title}>Документы семьи</Text>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.newGrid]: hasNewTableGrid(storage),
            })}
            onClick={onClickHandler}
        >
            <div className={styles.iconContainer}>
                <FolderIcon className={styles.icon} />
            </div>
            <div className={styles.details}>
                <div className={styles.titleContainer}>
                    <Text className={styles.title}>Документы семьи</Text>
                </div>
            </div>
        </div>
    );
};
